module.exports = __webpack_public_path__ + "static/media/not-found@2x.0d37295b.png";